import { ref } from '@vue/composition-api'

export const useFormRef = () => {
  const form = ref<HTMLFormElement | null>(null)

  const validate = (): boolean => {
    if (!form.value) {
      return false
    }
    return form.value.validate()
  }

  const reset = () => {
    if (!form.value) {
      return
    }
    return form.value.reset()
  }

  return { form, validate, reset }
}
